<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-text-field
          v-model="v.name.$model"
          :errorMessages="getValidationErrorText(v.name)"
          label="Наименование, указанное в ЕГРЮЛ"
          outlined
        />
      </v-col>
      <v-col cols="12">
        <v-text-field
          v-model="v.inn.$model"
          v-mask="['##########']"
          :errorMessages="getValidationErrorText(v.inn)"
          label="ИНН"
          outlined
          :disabled="true"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { maxLength, minLength, required } from 'vuelidate/lib/validators';
import { getValidationErrorText, EMOJI, INN_ROD } from '@/utils/validate';

export const foreignOrganizationModel = {
  name: '',
  inn: '',
};

export const foreignOrganizationValidation = {
  name: {
    required,
    maxLength: maxLength(1000),
    EMOJI,
  },
  inn: {
    required,
    minLength: minLength(10),
    INN: INN_ROD,
  },
};

export default {
  name: 'ForeignOrganization',
  props: {
    v: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    getValidationErrorText,
  }),
};
</script>
